export enum Authority {
    editor = 'ROLE_PRS_Editor',
    admin = 'ROLE_Super_Admin'
}
